import React, {useEffect, useRef} from 'react';
import {Animated, Easing, Platform} from 'react-native';
import styled from 'styled-components/native';
import {colors} from '../../theme/colors';
import {getByScreenSize} from '../../utils/responsive';

const Container = styled.View`
  justify-content: center;
  align-items: center;
`;
const ContentContainer = styled(Animated.View)`
  width: ${({theme}) =>
    getByScreenSize(
      theme.text.s2 * 1.5,
      theme.text.s2 * 1.3,
      theme.text.s2 * 1.7,
    )}px;
  height: ${({theme}) =>
    getByScreenSize(
      theme.text.s2 * 1.5,
      theme.text.s2 * 1.3,
      theme.text.s2 * 1.7,
    )}px;
  justify-content: center;
  align-items: center;
`;
const Item = styled(Animated.View)`
  width: ${({theme}) =>
    getByScreenSize(
      theme.text.s2 * 1.5,
      theme.text.s2 * 1.3,
      theme.text.s2 * 1.7,
    )}px;
  height: ${({theme}) =>
    getByScreenSize(
      theme.text.s2 * 1.5,
      theme.text.s2 * 1.3,
      theme.text.s2 * 1.7,
    )}px;
  border-width: 0;
  background-color: transparent;
  position: absolute;
  justify-content: center;
`;
const InnerItem = styled.View<{circleColor?: string}>`
  width: ${({theme}) =>
    getByScreenSize(
      theme.text.s2 / 5,
      theme.text.s2 / 6,
      theme.text.s2 / 4.5,
    )}px;
  height: ${({theme}) =>
    getByScreenSize(
      theme.text.s2 / 5,
      theme.text.s2 / 6,
      theme.text.s2 / 4.5,
    )}px;
  border-radius: ${({theme}) =>
    getByScreenSize(
      theme.text.s2 / 10,
      theme.text.s2 / 12,
      theme.text.s2 / 9,
    )}px;
  background-color: ${({circleColor}) => circleColor || colors.tertiary};
`;
const Loader = ({color}: {color?: string}) => {
  const animation = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    Animated.loop(
      Animated.sequence([
        Animated.timing(animation, {
          toValue: 1,
          duration: 3000,
          easing: Easing.linear,
          useNativeDriver: Platform.OS !== 'web',
        }),
      ]),
    ).start();
  }, []);

  const angle = animation.interpolate({
    inputRange: [0, 0.5, 1],
    outputRange: ['0deg', '72deg', '360deg'],
  });
  const angle0 = animation.interpolate({
    inputRange: [0, 0.5, 1],
    outputRange: ['0deg', '144deg', '360deg'],
  });
  const angle1 = animation.interpolate({
    inputRange: [0, 0.5, 1],
    outputRange: ['0deg', '216deg', '360deg'],
  });
  const angle2 = animation.interpolate({
    inputRange: [0, 0.5, 1],
    outputRange: ['0deg', '288deg', '360deg'],
  });
  const angle3 = animation.interpolate({
    inputRange: [0, 0.5, 1],
    outputRange: ['0deg', '360deg', '360deg'],
  });
  const outerAngle = animation.interpolate({
    inputRange: [0, 1],
    outputRange: ['0deg', '720deg'],
  });

  return (
    <Container>
      <ContentContainer style={{transform: [{rotate: outerAngle}]}}>
        <Item style={{transform: [{rotate: angle3}]}}>
          <InnerItem circleColor={color} />
        </Item>
        <Item style={{transform: [{rotate: angle2}]}}>
          <InnerItem circleColor={color} />
        </Item>
        <Item style={{transform: [{rotate: angle1}]}}>
          <InnerItem circleColor={color} />
        </Item>
        <Item style={{transform: [{rotate: angle0}]}}>
          <InnerItem circleColor={color} />
        </Item>
        <Item style={{transform: [{rotate: angle}]}}>
          <InnerItem circleColor={color} />
        </Item>
      </ContentContainer>
    </Container>
  );
};
export default Loader;
